import { MutationTree } from "vuex";
// interfaces
import { CouponsI } from "../interfaces/coupons.interface";

export enum PaymentMutations {
}

export const mutations: MutationTree<CouponsI> = {}
